<div class="message-list" aria-live="polite">
  <div class="date-divider"><span>Today</span></div>
  @for (message of messages(); track $index) {
  <article class="message-row" [class.user-row]="message.author === 'user'">
    @if (message.author === 'bot') {
    <div class="avatar avatar-tiny">S</div>
    }
    <div class="message-content">
      @if (message.attachments?.length) {
      <div class="message-attachments">
        @for (attachment of message.attachments; track attachment.id) {
        @if (attachment.dataUrl) {
        <img [src]="attachment.dataUrl" [alt]="attachment.name" [title]="attachment.name" />
        } @else {
        <span class="attachment-file-chip"><span class="attachment-file-glyph" aria-hidden="true">📎</span>{{ attachment.name }}</span>
        }
        }
      </div>
      }
      @if (message.author === 'bot' && $last && isRetrieving() && !message.text && !message.thinking) {
      <div class="message-bubble">
        <span class="retrieval-status">{{ retrievalStatus() }}</span>
        <div class="loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
      } @else if (message.text) {
      <div class="message-bubble" [innerHTML]="renderMarkdown(message.text)"></div>
      }
      @if (message.author === 'bot' && message.thinking) {
      <details class="thinking-details" [open]="!message.text">
        <summary>Thinking</summary>
        <div>{{ message.thinking }}</div>
      </details>
      }
      @if (message.author === 'bot' && message.toolInvocation?.name === 'open_bill_splitter') {
      <div class="interactive-tool"><app-bill-splitter mode="chat" [billId]="message.toolInvocation!.billId" [sourceText]="message.toolInvocation!.sourceText || ''" [sourceAttachment]="message.toolInvocation!.sourceAttachment" [initialInstructions]="message.toolInvocation!.instructions || ''" /></div>
      }
      @if (message.author === 'bot' && message.toolInvocation?.name === 'open_bill_viewer') {
      <div class="interactive-tool"><app-bill-history /></div>
      }
      @if (message.author === 'bot' && $last && isRetrieving() && message.thinking && !message.text) {
      <div class="loading-dots">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
      }
      @if (message.author === 'bot' && contextText && !($last && isRetrieving())) {
      <button type="button" class="context-toggle" (click)="toggleContext()">
        {{ showContext ? 'Hide' : 'Show' }} {{ contextLabel }}
      </button>
      @if (showContext) {
      <pre class="rag-context">{{ contextText }}</pre>
      }
      }
      <time>{{ message.time }}</time>
    </div>
  </article>
  }

  @if (isGeneratingTopics() || topics().length > 0) {
    <section class="related-topics" aria-label="Related topics">
      <div class="topics-heading">
        <div>
          <span class="topics-kicker">Continue exploring</span>
          <h3>Related topics</h3>
        </div>
        @if (topics().length > 0) {
        <span class="topic-count">{{ topics().length }} ideas</span>
        }
      </div>
      @if (isGeneratingTopics()) {
      <p>Finding useful follow-up topics…</p>
      } @else {
      <div class="topic-grid">
        @for (topic of topics(); track topic; let index = $index) {
          <button type="button" class="topic-card" (click)="selectTopic(topic)" [attr.aria-label]="'Ask: ' + topic">
            <span class="topic-number">{{ index + 1 }}</span>
            <span class="topic-copy">{{ topic }}</span>
            <svg class="topic-arrow" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M5 12h13M13 6l6 6-6 6" />
            </svg>
          </button>
        }
      </div>
      }
    </section>
  }
</div>
